import React from 'react';
import JobListingsSection from '../components/JobListingsSection';

const JobListingsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <JobListingsSection />
    </div>
  );
};

export default JobListingsPage;

